import {
    SET_SIDEBAR_ITEMS,
    SET_SELECTED_SIDEBAR_ITEM,
} from 'store/actions/sidebarActions';
import {
    CRUD_GET_LIST_SUCCESS,
} from 'store/actions/dataActions';

const initialState = 0;
export default (previousState = initialState, { type, payload, meta }) => {

    switch (type) {
        //다른 메뉴로 이동하는 경우 초기화
        case SET_SIDEBAR_ITEMS:
        case SET_SELECTED_SIDEBAR_ITEM:
            return initialState;

        case CRUD_GET_LIST_SUCCESS:
           if( meta.menu === 'DOCUMENT.FILE') {
                return payload.totalElements;
            }

            return previousState;

        default:
            return previousState;
    }

};